export const formatDate = (dateString?: string) => {
  if (!dateString) return "N/A";
  return new Date(dateString).toLocaleDateString();
};

export const calculateAge = (dateOfBirth?: string) => {
  if (!dateOfBirth) return null;
  try {
    const birthDate = new Date(dateOfBirth);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  } catch {
    return null;
  }
};

export const formatAddress = (address: any) => {
  if (typeof address === "object" && address !== null) {
    return `${address.street || ""} ${address.no || ""}, ${address.city || ""}, ${
      address.district || ""
    }, ${address.province || ""}, ${address.country || ""}`.trim() || "N/A";
  }
  return address || "N/A";
};

export const isStatusTrue = (status: any): boolean => {
  return status === "true" || status === true;
};

